// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loader_loadingContainer__VtqY2","loadingSpinner":"Loader_loadingSpinner__rnagm","spinner":"Loader_spinner__wp7ep"};